export default "__VITE_ASSET__SA3fN7sY__"